<template>
  <div>
    <div class="bg_box">
      <div class="box" >
        <div style="height: 20px"></div>
        <div class="aside_box">
          <el-input
            placeholder="请输入内容"
            v-model="keyword"
            class="input-with-select"
          >
            <el-select v-model="search_type" slot="prepend" placeholder="请选择">
              <el-option label="搜索人才" value="1"></el-option>
              <el-option label="搜索职位" value="2"></el-option>
              <el-option label="搜索企业" value="3"></el-option>
              <el-option label="搜索社团" value="4"></el-option>
            </el-select>
            <el-button slot="append" @click="search">搜索</el-button>
          </el-input>

          <div class="hotbox">
            <div class="leftbox">热门搜索：</div>
            <div class="rightbox" v-for="(item, index) in hotlist" :key="index">
              <div>{{ item }}</div>
            </div>
          </div>
          <div class="linebox"></div>
          <div class="classify">
            <div>
              <el-select v-model="education_type" placeholder="学历要求">
                <el-option
                  v-for="item in edu_option"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
              <el-select
                v-model="job_wanted"
                placeholder="求职状态"
                style="margin: 0 40px"
              >
                <el-option
                  v-for="item in wanted_option"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
              <el-select v-model="resume_identity" placeholder="求职身份">
                <el-option
                  v-for="item in identity_option"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
            <div @click="clear">清空搜索条件</div>
          </div>
        </div>

        <div class="content_box">
          <div class="sort_box">
            <div class="sort_boxchild">
              <span>薪资</span>
              <img
                v-show="flag3 == false"
                @click="paixu1()"
                src="@/assets/image/sort.png"
              />
              <img
                v-show="flag3 == true"
                @click="pai1()"
                src="@/assets/image/sort.png"
              />
            </div>
            <div class="sort_boxchild">
              <span>信用</span>
              <img
                v-show="flag4 == false"
                @click="paixu2()"
                src="@/assets/image/sort.png"
              />
              <img
                v-show="flag4 == true"
                @click="pai2()"
                src="@/assets/image/sort.png"
              />
            </div>
            <div class="sort_boxchild">
              <span>粉丝</span>
              <img
                v-show="flag5 == false"
                @click="paixu3()"
                src="@/assets/image/sort.png"
              />
              <img
                v-show="flag5 == true"
                @click="pai3()"
                src="@/assets/image/sort.png"
              />
            </div>
            <div class="sort_boxchild">
              <span>人气</span>
              <img
                v-show="flag6 == false"
                @click="paixu4()"
                src="@/assets/image/sort.png"
              />
              <img
                v-show="flag6 == true"
                @click="pai4()"
                src="@/assets/image/sort.png"
              />
            </div>
          </div>
          <div class="line_box"></div>

          <div class="hei_box">
            <div class="list_box">
              <div class="list_box_childs" ref="scroll">
                <div
                  class="list_box_childs_s"
                  v-for="(item, index) in list1"
                  :key="index"
                  @click="detail(item.user_app_id)"
                >
                  <div style="width:95%;margin:10px;auto;">
                    <div class="list_flag">
                      <div style="width: 10%">
                        <img :src="item.logo" />
                      </div>
                      <div style="width: 88%">
                        <div style="display: flex; align-items: center">
                          <span>{{ item.name }}</span>
                          <span class="sty">{{ item.class_name }}</span>
                          <span style="padding-right: 30px">{{
                            item.jzb_number
                          }}</span>
                          <div class="btn">去聊呗</div>
                        </div>
                        <div>
                          <span>{{ item.age }}岁</span>
                          <span style="padding: 0 15px">|</span>
                          <span>{{ item.sex }}</span>
                          <span style="padding: 0 15px">|</span>
                          <span style="padding-left: 40px"
                            >{{ item.salary }}/天</span
                          >
                        </div>
                        <div style="padding-top: 15px">
                          {{ item.introduce }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div style="height: 20px"></div>
        </div>
        <div style="height: 20px"></div>
      </div>

    </div>
  </div>
</template>

<script>
import { recommendsearch } from "@/api/director/talent/index";
import { searchlist } from "@/api/personal/job/index";
export default {
  data() {
    return {
      flag1: false,
      flag2: false,
      flag3: false,
      flag4: false,
      flag5: false,
      flag6: false,
      keyword: "",
      search_type: "",
      edu_option: [//学历1高中及以下 2 大专及以下 3 本科及以下 4 硕士及以下 5 博士及以下 6 在校生
        {
          value: "1",
          label: "不限",
        },
        {
          value: "2",
          label: "初中及以下",
        },
        {
          value: "3",
          label: "高中及以上",
        },
        {
          value: "4",
          label: "大专及以上",
        },
        {
          value: "5",
          label: "本科及以上",
        },
        {
          value: "6",
          label: "研究生及以上",
        },
        {
          value: "7",
          label: "在校大学生",
        },
        {
          value: "8",
          label: "非在校大学生",
        },
      ],
      wanted_option: [//job_wanted 求职状态 1随时到岗，2月内入职
       
        {
          value: "1",
          label: "随时到岗",
        },
        {
          value: "2",
          label: "月内到岗",
        },
      ],
      identity_option: [//求职人身份1职场人 2自由职业 3在校生
      
        {
          value: "1",
          label: "职场人",
        },
        {
          value: "2",
          label: "自由职业",
        },
        {
          value: "3",
          label: "在校生",
        },
      ],
      list1: [],
      education_type: "",//学历1高中及以下 2 大专及以下 3 本科及以下 4 硕士及以下 5 博士及以下 6 在校生
      job_wanted: "",
      resume_identity: "",
      hotlist: [
        "家政",
        "出纳",
        "人才资源经理",
        "机械工程师",
        "审计",
        "清洁工",
        "普工",
        "叉车司机",
        "塔吊司机",
      ],
      isLoad: true,
      msg: "正在加载",
      commid: "",
      usertype: "",
      lat: "",
      lng: "",
    };
  },
  created() {
    this.usertype = localStorage.getItem("user_type") == 2 ? 2 : 1;
    this.commid = this.$route.query.id;
    this.getlist();
  },
  mounted() {
    //开启滚动事件
    // window.addEventListener("scroll", this.onScroll);
  },
  destroyed() {
    //关闭滚动事件
    // window.removeEventListener("scroll", this.onScroll);
  },
  methods: {
   

    paixu1() {
      this.flag3 = true;
      let data = {
        keyword: this.keyword,
        order: "salaryStr",
        orderBy: "ASC",
      };
      recommendsearch(data).then((res) => {
        this.list1 = res.data.data;
      });
    },
    pai1() {
      this.flag3 = false;
      let data = {
        keyword: this.keyword,
        order: "salaryStr",
        orderBy: "DESC",
      };
      recommendsearch(data).then((res) => {
        this.list1 = res.data.data;
      });
    },

    paixu2() {
      this.flag4 = true;
      let data = {
        keyword: this.keyword,
        order: "credit",
        orderBy: "ASC",
      };
      recommendsearch(data).then((res) => {
        this.list1 = res.data.data;
      });
    },
    pai2() {
      this.flag4 = false;
      let data = {
        keyword: this.keyword,
        order: "credit",
        orderBy: "DESC",
      };
      recommendsearch(data).then((res) => {
        this.list1 = res.data.data;
      });
    },

    paixu3() {
      this.flag5 = true;
      let data = {
        keyword: this.keyword,
        order: "fans",
        orderBy: "ASC",
      };
      recommendsearch(data).then((res) => {
        this.list1 = res.data.data;
      });
    },
    pai3() {
      this.flag5 = false;
      let data = {
        keyword: this.keyword,
        order: "fans",
        orderBy: "DESC",
      };
      recommendsearch(data).then((res) => {
        this.list1 = res.data.data;
      });
    },

    paixu4() {
      this.flag6 = true;
      let data = {
        keyword: this.keyword,
        order: "popularity",
        orderBy: "ASC",
      };
      recommendsearch(data).then((res) => {
        this.list1 = res.data.data;
      });
    },
    pai4() {
      this.flag6 = false;
      let data = {
        keyword: this.keyword,
        order: "popularity",
        orderBy: "DESC",
      };
      recommendsearch(data).then((res) => {
        this.list1 = res.data.data;
      });
    },
   

    clear() {
      this.keyword = "";
      this.education_type = "";
      this.job_wanted = "";
      this.resume_identity = "";
      this.getlist();
    },
    jobdetail(id) {
      this.$router.push({ name: "position-detail", query: { id: id } });
    },
    detail(id) {
      this.$router.push({ name: "member-index", query: { id: id } });
    },
  
    //搜索事件
    search() {

        let data = {
          keyword: this.keyword,
          education_type:this.education_type,
          job_wanted:this.job_wanted,
          resume_identity:this.resume_identity,
        };
        recommendsearch(data).then((res) => {
          this.list1 = res.data.data;
        });
    },
    getlist() {
      recommendsearch().then((res) => {
        this.list1 = res.data.data;
      });
    },
    onScroll() {
      //可滚动容器的高度
      let innerHeight = this.$refs.scroll.clientHeight;
      //屏幕尺寸高度
      let outerHeight = document.documentElement.clientHeight;
      //可滚动容器超出当前窗口显示范围的高度
      let scrollTop = document.documentElement.scrollTop;
      //避免切换时读取到异常高度
      if (scrollTop == 0) {
        innerHeight = 10000;
      }
      //scrollTop在页面为滚动时为0，开始滚动后，慢慢增加，滚动到页面底部时，出现innerHeight < (outerHeight + scrollTop)的情况，严格来讲，是接近底部。
      console.log(innerHeight + " " + outerHeight + " " + scrollTop);
      if (this.isLoad) {
        if (innerHeight <= outerHeight + scrollTop) {
          //此处添加自定义操作
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-select .el-input {
  width: 100px;
}
.input-with-select .el-input-group__prepend {
  background-color: #fff;
}
.el-select .el-input__inner {
  border: none;
}
.el-select .el-input {
  width: 100px;
}
.input-with-select .el-input-group__prepend {
  background-color: #fff;
}
.el-select .el-input__inner {
  border: none;
}

.bg_box {
  background-color: #eeeeee;
  .box {
    width: 1200px;
    margin: auto;

    .content_box {
      opacity: 1;
      background: #ffffff;
      box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
      border-radius: 8px;
      .content_child {
        width: 95%;
        padding-bottom: 20px;
        padding-top: 20px;
        margin: auto;
      }
      .sort_box {
        padding-top: 20px;
        width: 95%;
        padding-bottom: 30px;
        margin: auto;
        display: flex;
        align-items: center;
        .sort_boxchild {
          display: flex;
          justify-content: center;
          align-items: center;
          margin-right: 30px;
          img {
            width: 20px;
            height: 20px;
          }
        }
      }
      .line_box {
        height: 2px;
        background-color: #dadada;
        margin-bottom: 5px;
      }
      .hei_box {
        height: 600px;
      }
      .list_box {
        width: 95%;
        height: 100%;
        padding-bottom: 20px;
        padding-top: 20px;
        margin: auto;
        .list_box_childs {
          width: 100%;
          height: 100%;
          margin: auto;
          display: flex;
          flex-wrap: wrap;
          overflow-y: scroll;
          .list_box_childs_s:hover {
            box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
          }
          .list_box_childs_s {
            font-size: 12px;
            width: 48.5%;
            border: 1px solid #c8c8c8;
            border-radius: 8px;
            margin-right: 10px;
            margin-bottom: 10px;
            height: 143px;
            .sty {
              padding: 0 30px;
            }
            .list_flag_bottom {
              display: flex;
              justify-content: space-between;
              align-items: center;
              padding-top: 5px;
            }
            .list_flag_bottoms {
              display: flex;
              align-items: center;
              padding-top: 5px;
              .list_flag_bottom_child {
                padding: 2px 5px;
                border: 1px solid #999999;
                margin-right: 10px;
                border-radius: 5px;
              }
            }
            .list_flags {
              display: flex;
              justify-content: space-between;
              align-items: center;
              .list_flag_child {
                .list_flag_text {
                  font-weight: bold;
                  font-size: 16px;
                  width: 150px;
                  overflow: hidden;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                }
                width: 88%;
                height: 50px;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                align-items: left;
              }
            }
            .list_flag {
              display: flex;
              justify-content: space-between;
              align-items: center;
              .btn {
                width: 80px;
                height: 30px;
                border-radius: 8px;
                background-color: #4a72dd;
                color: white;
                text-align: center;
                line-height: 30px;
              }
            }
            img {
              width: 50px;
              height: 50px;
              border-radius: 50%;
            }
          }
        }
      }
    }

    .aside_box {
      opacity: 1;
      background: #ffffff;
      box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
      border-radius: 8px;
      // margin-top: 20px;
      margin-bottom: 30px;
      padding: 20px;
      .classify {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
      .linebox {
        height: 2px;
        background-color: #dadada;
        margin-bottom: 20px;
      }
      .hotbox {
        margin: 20px 0;
        display: flex;
        align-items: center;
        .leftbox {
          padding-right: 20px;
        }
        .rightbox {
          color: #4c71db;
          display: flex;
          align-items: center;
          div {
            padding: 0 20px;
          }
        }
      }
    }
  }
}
</style>
